module.exports = __webpack_public_path__ + "img/13.RoyalEnfield2010.aafabfdc.png";